import { render, staticRenderFns } from "./CollectionFilterControlTypeColour.vue?vue&type=template&id=8eff0748"
import script from "./CollectionFilterControlTypeColour.vue?vue&type=script&setup=true&lang=js"
export * from "./CollectionFilterControlTypeColour.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports